//import * as lib from '../lib/lib'
import $ from 'jquery';

const EXPANDED_CLASS = 'expanded'

class Footer {
    constructor(element) {
        if (!element) return

        this.element = element

        this.iniElements()
        this.iniExpandableText()
    }

    iniElements() {
        this.textItems = this.element.querySelectorAll('.footer__item')
    }

    iniExpandableText() {
        this.textItems.forEach((i) => {
            i.addEventListener('click', (e) => {
                if (window.innerWidth <= 768) {
                    const $item = $(e.currentTarget)

                    if ($item.hasClass(EXPANDED_CLASS)) {
                        this.collapseText($item)
                    } else {
                        this.expandText($item)
                    }
                }
            })
        })
    }

    collapseText(target) {
        target.find('.footer__menu-lnks').slideUp()
        target.removeClass(EXPANDED_CLASS)
    }

    expandText(target) {
        const self = this

        $(this.textItems)
            .not(target)
            .each(function () {
                self.collapseText($(this))
            })

        target.addClass(EXPANDED_CLASS)
        target.find('.footer__menu-lnks').slideDown()
    }
}

export default Footer
